import ForgotPasswordPageContent from "@/app/forgot-password/page";

export default function ForgotPasswordPage() {
  return <ForgotPasswordPageContent />;
}
